import { useTranslation } from 'react-i18next'

import CartModal from '@features/cart/ui/modal'
import styles from '@features/cart/ui/modal/styles.module.scss'
import { useModalStore } from '@features/modal'


export default function useCartModal () {
  const { openModal, closeModal } = useModalStore()
  const { t: tca } = useTranslation('cart')

  const openCartModal = (reProps = {}) => {
    openModal('cart', <CartModal />, {
      title: tca('preview.title'),
      hideIconClose: false,
      disabledScroll: true,
      classes: {
        content: styles.cartModal,
      },
      ...reProps
    })
  }

  const closeCartModal = () => {
    closeModal('cart')
  }

  return {
    openCartModal,
    closeCartModal,
  }
}
